import { Td, Tr } from 'app/components/Table';
import { ListItemAvatar, ListItemText } from 'app/components/ChakraTableList';
import { getAvatarImage } from 'app/utils/utils';
import { ProfileCard } from 'types/profile';
import { formatCountryLocation } from 'app/utils/helpers';
import { DDL } from 'types/general.types';

interface CollaboratorResultsRowProps {
  collaborator: ProfileCard;
  countriesDDL: DDL;
  onSearchByCollaborator: (collaboratorDetails: ProfileCard) => void;
}

export const CollaboratorResultsRow = ({
  collaborator,
  countriesDDL,
  onSearchByCollaborator,
}: CollaboratorResultsRowProps) => {
  return (
    <Tr
      zIndex={1}
      position="relative"
      role="row"
      clickable
      onClick={() => {
        onSearchByCollaborator(collaborator);
      }}
    >
      <Td isAvatar sx={{ overflow: 'visible' }}>
        <ListItemAvatar
          src={getAvatarImage(collaborator?.profileImages)}
          initials={collaborator?.initials}
          colors={collaborator?.avatarColors}
        />
      </Td>
      <Td data-testid="collaborator-display-name" sx={{ pl: 0 }}>
        <ListItemText
          title={collaborator?.displayName}
          primary={collaborator?.displayName}
          secondary={formatCountryLocation(countriesDDL || {}, {
            countryCode: collaborator?.countryCode,
            city: collaborator?.city,
          })}
          secondaryTextProps={{
            fontSize: 'xs',
            color: 'textSubdued',
          }}
        />
      </Td>
      <Td className="gap" />
    </Tr>
  );
};
